import { colorSet } from '@components/Provider';
import { Chip } from '@material-ui/core';
import AppConfig from '@config';

const StageChipPresenter = () => {
  const chipLabel = getChipLabelByHostname(window.location.host);

  if (!chipLabel) {
    return null;
  }

  const { color, label } = chipLabel;
  return (
    <Chip
      color="primary"
      label={label}
      size="small"
      style={{
        backgroundColor: color,
        backgroundImage: color,
        marginLeft: 8
      }}
    />
  );
};

export default StageChipPresenter;

const getChipLabelByHostname = (host: string) => {
  if (AppConfig.baseUrl?.includes('staging')) {
    return { label: 'STAGING', color: colorSet.errorMain };
  }
  if (AppConfig.baseUrl?.includes('develop')) {
    return { label: 'DEV', color: colorSet.primary500 };
  }
  if (AppConfig.baseUrl?.includes('pre')) {
    return { label: 'PRE', color: colorSet.successMain };
  }
  if (host.includes('test')) {
    return { label: 'TEST', color: colorSet.gray900 };
  }
  if (host.includes('bluegreen')) {
    return {
      label: 'BLUE/GREEN',
      color: `linear-gradient(90deg, ${colorSet.primary500} 0%, ${colorSet.successMain} 100%)`
    };
  }
  return null;
};
